var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c(
        "div",
        { staticClass: "text-remark" },
        [
          _vm.parentService && _vm.parentService.can_book_package === 1
            ? _c("booking-plan", {
                attrs: { packageType: _vm.packageType },
                on: { selectPackageType: _vm.selectPackageType }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      Number(_vm.bookingData.professional_id) === 0 &&
      _vm.parentService && !_vm.parentService.is_experience_service &&
      _vm.user && _vm.user.flagBlack === 0
        ? _c("section", [
            !_vm.packageType
              ? _c("div", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "message.booking.new_booking.select_booking_type"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "exp" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.bookingType,
                                expression: "bookingType"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "bookingType",
                              id: "normal_booking",
                              value: "normal"
                            },
                            domProps: {
                              checked: _vm._q(_vm.bookingType, "normal")
                            },
                            on: {
                              change: function($event) {
                                _vm.bookingType = "normal"
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "mb-0",
                              attrs: { for: "normal_booking" }
                            },
                            [
                              _c("span"),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.booking_type_normal"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp pt-4" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.bookingType,
                                expression: "bookingType"
                              }
                            ],
                            attrs: {
                              type: "radio",
                              name: "bookingType",
                              id: "flexible_booking",
                              value: "flexible"
                            },
                            domProps: {
                              checked: _vm._q(_vm.bookingType, "flexible")
                            },
                            on: {
                              change: function($event) {
                                _vm.bookingType = "flexible"
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "mb-0",
                              attrs: { for: "flexible_booking" }
                            },
                            [
                              _c("span"),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.booking_type_flexible"
                                    )
                                  ) +
                                  "\n                  "
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block text-comment text-secondary pt-1",
                                  staticStyle: { "padding-left": "2.2rem" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.new_booking.booking_type_flexible_remark"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              : _c("div", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "message.booking.new_booking.select_package_type"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "exp" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              id: "package_unlimited"
                            },
                            domProps: {
                              checked:
                                _vm.packageType &&
                                _vm.packageType.category === "unlimited"
                            },
                            on: {
                              change: function($event) {
                                return _vm.selectPackageType("unlimited")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "mb-0",
                              attrs: { for: "package_unlimited" }
                            },
                            [
                              _c("span"),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.package_type_unlimited"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "exp pt-4" }, [
                        _c("div", { staticClass: "checkbox" }, [
                          _c("input", {
                            attrs: { type: "checkbox", id: "package_flexible" },
                            domProps: {
                              checked:
                                _vm.packageType &&
                                _vm.packageType.category === "flexible"
                            },
                            on: {
                              change: function($event) {
                                return _vm.selectPackageType("flexible")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "mb-0",
                              attrs: { for: "package_flexible" }
                            },
                            [
                              _c("span"),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.package_type_flexible"
                                    )
                                  ) +
                                  "\n                  "
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block text-comment text-secondary pt-1",
                                  staticStyle: { "padding-left": "2.2rem" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.new_booking.booking_type_flexible_remark"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                (_vm.bookingType === "normal" && !_vm.packageType) ||
                (_vm.packageType && _vm.packageType.category === "unlimited"),
              expression:
                "(bookingType === 'normal' && !packageType) || (packageType && packageType.category === 'unlimited')"
            }
          ]
        },
        [
          _c("div", { staticClass: "my-3" }, [
            _c("b", [_vm._v(_vm._s(_vm.message.text))])
          ]),
          _vm._v(" "),
          _vm.packageType && _vm.packageType.category === "unlimited"
            ? _c("div", [
                _vm.professionalId
                  ? _c(
                      "section",
                      { staticClass: "text-remark" },
                      [
                        _c("professional-multi-dates-calendar", {
                          attrs: {
                            professionalId: _vm.bookingData.professional_id,
                            maxNum: _vm.packageType.num_per_package,
                            workHours: _vm.bookingData.work_hour,
                            packageType: _vm.packageType
                          },
                          on: {
                            updateData: _vm.updateProfessionalMultiDates,
                            updateNumPackageSelectedDates:
                              _vm.updateNumPackageSelectedDates
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "section",
                      [
                        _c("multi-dates-calendar", {
                          attrs: {
                            maxNum: _vm.packageType.num_per_package,
                            serviceId: _vm.parentService
                              ? _vm.parentService.id
                              : 1,
                            sameDayBookingConfig: _vm.sameDayBookingConfig
                          },
                          on: { selectDate: _vm.onDateChange }
                        }),
                        _vm._v(" "),
                        _vm.multiDates && _vm.multiDates.length > 0
                          ? _c(
                              "section",
                              { staticClass: "mt-4 text-remark" },
                              [
                                _c("package-discount", {
                                  attrs: {
                                    numDates: _vm.multiDates.length,
                                    packageType: _vm.packageType
                                  },
                                  on: {
                                    selectPackageTypeDiscount:
                                      _vm.selectPackageTypeDiscount
                                  }
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.multiDates, function(date) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-pill py-2 px-3 mr-2 mb-2 badge-light"
                                    },
                                    [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(_vm._f("shortDate")(date)) +
                                          "\n        "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errorBookingDate
                          ? _c(
                              "div",
                              { staticClass: "form-alert-text -status-alert" },
                              [_vm._v(_vm._s(_vm.errorBookingDateText))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
              ])
            : _c("div", [
                _c("div", {
                  staticClass: "multiDatesCalendar datepicker-here"
                }),
                _vm._v(" "),
                _vm.hasErrors.indexOf("date") > -1
                  ? _c("div", { staticClass: "help text-danger mt-2" }, [
                      _vm._v("กรุณาเลือกวัน")
                    ])
                  : _vm._e()
              ]),
          _vm._v(" "),
          (_vm.packageType && _vm.professionalId === 0) || !_vm.packageType
            ? _c("section", [
                _vm.availableTimes.length > 0
                  ? _c("div", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row no-gutters mt-2" },
                        _vm._l(_vm.availableTimes, function(time, index) {
                          return _c(
                            "div",
                            { staticClass: "col-md-3 col-4 p-1" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-info btn-block btn-small-group text-center",
                                  class: { active: _vm.selectedTime === time },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSelectedTime(time)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(time) + "\n              ")]
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.hasErrors.indexOf("time") > -1
                        ? _c("div", { staticClass: "help text-danger mt-2" }, [
                            _vm._v("กรุณาเลือกเวลา")
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.packageType && _vm.packageType.category === "flexible"
        ? _c("div", { staticClass: "my-3" }, [
            _c("b", { staticClass: "d-inline-block pb-2" }, [
              _vm._v(
                _vm._s(_vm.$t("message.booking.new_booking.how_many_package"))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "select-jumbo" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.packageTypeDiscount,
                      expression: "packageTypeDiscount"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.packageTypeDiscount = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.packageType.package_type_discounts, function(
                  packageTypeDiscount
                ) {
                  return _c(
                    "option",
                    { domProps: { value: packageTypeDiscount } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("multiLangName")(packageTypeDiscount)) +
                          "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-3" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-block btn-info",
            attrs: { disabled: _vm.validateForm() },
            on: { click: _vm.submit }
          },
          [_vm._v("ยืนยัน\n      ")]
        ),
        _vm._v(" "),
        _vm.route === "select-professional-first" &&
        _vm.bookingData.route === "select-professional-first"
          ? _c("div", { staticClass: "mt-3" }, [
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "text-remark" }, [
                _vm._v(
                  "\n          หากต้องการจองบริการวันนี้ หรือเช็คแล้วตารางผู้ให้บริการไม่ตรงกับวันเวลาที่คุณต้องการ\n          กรุณาติดต่อแอดมินเพื่อช่วยประสานงานให้ค่ะ\n        "
                )
              ]),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3 text-center" }, [
      _c("b", [_vm._v("เวลา")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-3 text-center" }, [
      _c(
        "a",
        {
          staticClass: "text-center text-primary-link",
          attrs: {
            href: "https://line.me/R/ti/p/%40hnk7011n",
            target: "_blank"
          }
        },
        [_vm._v("\n            ติดต่อแอดมิน\n          ")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c994955e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c994955e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/DateTimeMessage.vue
// module id = 2102
// module chunks = 0